<template>
  <div class="i-date i-date-time">
    <div class="field-label">
      {{ placeholder }}
    </div>
    <img src="../../assets/app/icons/calender-icon.svg" class="calendar-icon">
    <VueCtkDateTimePicker
      formatted="l"
      no-label
      only-date
      :label="dateValue"
      :no-button-now="noButtonNow"
      :noClearButton="noClearButton"
      :value="selectedDate"
      :no-header="true"
      :only-date="true"
      :max-date="maxDate"
      :locale="Intl.DateTimeFormat().resolvedOptions().locale"
      @input="onInput"
      @validate="onValidate"
    />
  </div>
</template>

<script>

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import {addMinutes, endOfDay, startOfDay} from 'date-fns'

export default {
  name: "IDate",
  components: {VueCtkDateTimePicker},
  props: {
    value: {
      type: [Date, String, Number],
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    isAllDay: {
      type: Boolean,
      default: false,
    },
    noButtonNow: {
      type: Boolean,
      default: true,
    },
    noClearButton: {
      type: Boolean,
      default: true,
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    customMaxDate: {
      type: String
    },
    customSelectedDate: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      selectedDate: null,
    }
  },

  computed: {
    maxDate() {
      return this.customMaxDate ? this.customMaxDate : new Date().toISOString()
    },
    dateValue() {
      let dateFormatter = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale,)

      if (this.value !== null && this.value !== undefined) {
        return dateFormatter.format(new Date(this.value));
      } else {
        return dateFormatter.format(new Date());
      }
    },
  },

  methods: {
    onInput(val) {
      if (val && typeof val === 'string') {
        val = val.replace(/-/g, '/')
        const isoDate = new Date(val)
        let dateFrom = startOfDay(isoDate)

        this.minDate = dateFrom

        if (this.isAllDay) {
          dateFrom = endOfDay(isoDate)
        }

        const finalDate = addMinutes(dateFrom, isoDate.getTimezoneOffset() * (-1))

        if (this.customSelectedDate) {
          this.selectedDate = new Date(finalDate).toISOString();
        } else {
          this.selectedDate = new Date(finalDate).toISOString();
          this.$emit('input', dateFrom.toISOString());
        }
      } else {
        this.$emit('input', null);
        this.selectedDate = null;
      }
    },
    onValidate() {
      this.$emit('input', this.selectedDate);
    }
  },

  created() {
    this.selectedDate = this.customSelectedDate;
  }
}
</script>

<style lang="scss">
@import "IDateTime";
</style>
